import type { CheckoutWebComponents, Component } from '@checkout.com/checkout-web-components'
import { BaseCheckoutPayFlowModule, PAYMENT_EXECUTION_MODE, type PaymentExecutionMode } from './BaseCheckoutPayFlowModule'
import { PAYMENT_DIALOG_TYPE, type PaymentDialogType } from './payment-dialog-type'

export class CheckoutPayWeChatPayHkModule extends BaseCheckoutPayFlowModule {
  protected createComponent(
    checkout: CheckoutWebComponents,
    callbacks: Parameters<BaseCheckoutPayFlowModule['createComponent']>[1],
  ): Component {
    return checkout.create('wechatpay', { ...callbacks, showPayButton: false })
  }

  public override getPaymentExecutionMode(): PaymentExecutionMode {
    return PAYMENT_EXECUTION_MODE.CKO_REDIRECT
  }

  public override mountsInDialog(): boolean {
    return true
  }

  public override getPaymentDialogType(): PaymentDialogType | null {
    return PAYMENT_DIALOG_TYPE.REDIRECT_APM
  }
}
